import { ProductsConfig, Vehicle } from 'data-layer-cr/dist/models';
import {
  COMPLETE_VEHICLE,
  THIRD_PARTY_PACK,
  THIRD_PARTY_VEHICLE,
} from 'data-layer-cr/dist/constants/products';

export const CAR_YEAR_THRESHOLD = 12;
export const MIN_PRICE_FOR_COMPLETE = 4675;

function vehicleAge(vehicle: Vehicle): number {
  const currentYear = new Date().getFullYear();
  const vehicleYear = vehicle.modelYear;
  return currentYear - vehicleYear;
}

export function defaultProductForVehicle(vehicle: Vehicle): string {
  const age = vehicleAge(vehicle);
  if (
    age <= CAR_YEAR_THRESHOLD &&
    vehicle.value >= MIN_PRICE_FOR_COMPLETE &&
    vehicle.modelGroupId !== null
  ) {
    return COMPLETE_VEHICLE;
  }
  return THIRD_PARTY_PACK;
}

export function availableProductsForVehicle(vehicle: Vehicle): string[] {
  const acceptedProducts: string[] = [THIRD_PARTY_PACK, THIRD_PARTY_VEHICLE];
  const age = vehicleAge(vehicle);
  if (
    age <= CAR_YEAR_THRESHOLD &&
    vehicle.value >= MIN_PRICE_FOR_COMPLETE &&
    vehicle.modelGroupId !== null
  ) {
    acceptedProducts.push(COMPLETE_VEHICLE);
  }
  return acceptedProducts;
}

/* This disables customization button, since it only allows for 1 product.
 ** This way it only lets the user create for that specific allowed product.
 */
export function disableButtonProductsConfig(
  productsConfig: ProductsConfig | undefined,
): boolean {
  if (productsConfig) {
    return productsConfig.allowedProducts.length === 1;
  }
  return false;
}

export function isNotComplete(product: string): boolean {
  return [THIRD_PARTY_PACK, THIRD_PARTY_VEHICLE].includes(product);
}
